import React from 'react';

const NotFoundPage = () =>
  <div>
    <div style={{display:"flex", justifyContent:"flex-start", marginBottom:"20px"}}>
      <img src="wm_logo_small.png" alt="Watermark Medical" title="Watermark Medical" height="47px" width="80px" />
    </div> 
    <h2>404 page not found</h2>
    <p></p>
    <p>We are sorry but the page you are looking for does not exist.</p>
    <p>Please contact Watermark Medical for support at 1-866-875-9765.</p>
  </div>

export default NotFoundPage;